import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "about-section",
  id: "about"
}
const _hoisted_2 = { class: "about-container" }
const _hoisted_3 = { class: "about-image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "about-content" }
const _hoisted_6 = { class: "about-features" }
const _hoisted_7 = { class: "feature-item" }
const _hoisted_8 = { class: "feature-item" }
const _hoisted_9 = { class: "feature-item" }
const _hoisted_10 = { class: "team-section" }
const _hoisted_11 = { class: "team-card" }
const _hoisted_12 = { class: "team-icon" }
const _hoisted_13 = { class: "opening-card" }
const _hoisted_14 = { class: "team-icon" }

import {CheckCircle, Clock3, Users} from "lucide-vue-next";

import "@/assets/styles/about.css";

import aboutImg from "@/assets/images/about-garden.png";

export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(aboutImg),
          alt: "Gartenbau Team"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "section-badge" }, " Über uns ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("h2", null, [
          _createTextVNode(" Garten- & Landschaftsbau"),
          _createElementVNode("br"),
          _createTextVNode(" mit Erfahrung und Leidenschaft ")
        ], -1)),
        _cache[5] || (_cache[5] = _createElementVNode("p", null, " Wir gestalten moderne Außenanlagen, pflegen Gärten und schaffen individuelle Lösungen für private sowie gewerbliche Kunden. ", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("p", null, " Qualität, Zuverlässigkeit und saubere Arbeit stehen bei uns an erster Stelle. ", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(CheckCircle)),
            _cache[0] || (_cache[0] = _createTextVNode(" Persönliche Beratung ", -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(CheckCircle)),
            _cache[1] || (_cache[1] = _createTextVNode(" Zuverlässige Umsetzung ", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(CheckCircle)),
            _cache[2] || (_cache[2] = _createTextVNode(" Individuelle Gartenkonzepte ", -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(Users))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Günther Gärtner", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("span", null, " Garten- & Landschaftsbau ", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", null, " „Wir möchten Außenbereiche schaffen, in denen sich Menschen wirklich wohlfühlen.“ ", -1))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(Clock3))
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Erreichbarkeit", -1)),
        _cache[11] || (_cache[11] = _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("span", null, "Montag – Freitag"),
            _createElementVNode("span", null, "08:00 – 17:00")
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("span", null, "Wochenende"),
            _createElementVNode("span", null, "geschlossen")
          ])
        ], -1))
      ])
    ])
  ]))
}
}

})